import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ fill = "#FFF" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19.25"
      height="22"
      viewBox="0 0 19.25 22"
    >
      <g id="_7zip" data-name="7zip" transform="translate(-565 -298)">
        <g id="file-extension" transform="translate(565 298)">
          <path
            id="Контур_725"
            data-name="Контур 725"
            d="M20.7,0H32.387l6.192,6.168V20.625A1.375,1.375,0,0,1,37.2,22H20.7a1.375,1.375,0,0,1-1.375-1.375V1.375A1.375,1.375,0,0,1,20.7,0Z"
            transform="translate(-19.329)"
            fill="#333"
          />
          <path
            id="Контур_726"
            data-name="Контур 726"
            d="M209.125,6.367h-4.793a1.375,1.375,0,0,1-1.375-1.375V.193Z"
            transform="translate(-189.894 -0.179)"
          />
          <path
            id="Контур_823"
            data-name="Контур 823"
            d="M3.226-3.738,1.632,0H.589l1.6-3.5H.152v-.762H3.226ZM5.131-.791H7.17V0H3.848V-.542l2.033-2.93H3.836v-.794H7.15v.527ZM8.912,0H7.886V-4.266H8.912Zm1.923-1.447V0H9.807V-4.266h1.7a1.983,1.983,0,0,1,.866.18,1.358,1.358,0,0,1,.583.513,1.4,1.4,0,0,1,.207.754,1.234,1.234,0,0,1-.447,1,1.854,1.854,0,0,1-1.226.374Zm0-.794h.674a.635.635,0,0,0,.456-.149.555.555,0,0,0,.157-.422.686.686,0,0,0-.161-.478.571.571,0,0,0-.439-.182h-.686Z"
            transform="translate(3 17)"
            fill="#fff"
          />
        </g>
        <g id="zip-2" transform="translate(569 298)">
          <g
            id="Сгруппировать_4114"
            data-name="Сгруппировать 4114"
            transform="translate(2 2)"
          >
            <g
              id="Сгруппировать_4113"
              data-name="Сгруппировать 4113"
              transform="translate(0)"
            >
              <rect
                id="Прямоугольник_855"
                data-name="Прямоугольник 855"
                width="2"
                height="2"
                fill="#fff"
              />
            </g>
          </g>
          <g
            id="Сгруппировать_4116"
            data-name="Сгруппировать 4116"
            transform="translate(0 0)"
          >
            <g
              id="Сгруппировать_4115"
              data-name="Сгруппировать 4115"
              transform="translate(0)"
            >
              <rect
                id="Прямоугольник_856"
                data-name="Прямоугольник 856"
                width="2"
                height="2"
                fill="#fff"
              />
            </g>
          </g>
          <g
            id="Сгруппировать_4118"
            data-name="Сгруппировать 4118"
            transform="translate(0 4)"
          >
            <g
              id="Сгруппировать_4117"
              data-name="Сгруппировать 4117"
              transform="translate(0)"
            >
              <rect
                id="Прямоугольник_857"
                data-name="Прямоугольник 857"
                width="2"
                height="2"
                fill="#fff"
              />
            </g>
          </g>
          <g
            id="Сгруппировать_4120"
            data-name="Сгруппировать 4120"
            transform="translate(2 6)"
          >
            <g
              id="Сгруппировать_4119"
              data-name="Сгруппировать 4119"
              transform="translate(0)"
            >
              <rect
                id="Прямоугольник_858"
                data-name="Прямоугольник 858"
                width="2"
                height="2"
                fill="#fff"
              />
            </g>
          </g>
          <g
            id="Сгруппировать_4122"
            data-name="Сгруппировать 4122"
            transform="translate(0 8)"
          >
            <g
              id="Сгруппировать_4121"
              data-name="Сгруппировать 4121"
              transform="translate(0)"
            >
              <rect
                id="Прямоугольник_859"
                data-name="Прямоугольник 859"
                width="2"
                height="2"
                fill="#fff"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default memo(Icon);
